export default "__VITE_ASSET__CPnSs$CU__"